export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10883.376069bd.jpg";